import DateFnsUtils from '@date-io/date-fns';
import {useIntl} from 'react-intl';
import useLocale from '../locale/useLocale';
import {KeyboardDatePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import {enUS, fi, sv} from 'date-fns/locale';
import messages from '@super-template/messages';
import format from "date-fns/format";

const getLocale = (locale) => locale === "sv-SE" ? sv : locale === "en-US" ? enUS : fi;

class LocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText(date) {
    return format(date, "d.M.yyyy", {locale: this.locale});
  }
  getCalendarHeaderText(date) {
    return format(date, "LLLL yyyy", {locale: this.locale});
  }
}

export default (props) => {
  const intl = useIntl();
  const locale = getLocale(useLocale());
  return (
    <MuiPickersUtilsProvider utils={LocalizedUtils} locale={locale}>
      <KeyboardDatePicker
        size="small" variant="inline" format="dd.MM.yyyy" placeholder={intl.formatMessage(messages.date_format)} autoOk
        invalidDateMessage={intl.formatMessage(messages.invalid_date)} {...props}/>
    </MuiPickersUtilsProvider>
  );
};
